import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IUserService } from "@saif-reporting/domain/interfaces/services/IUserService.js";
import type { ChangePasswordRequest } from "@saif-reporting/domain/dtos/authDtos.js";
import type { UserDto } from "@saif-reporting/domain/dtos/models/UserDto.js";
import type { Paginated } from "@saif-reporting/domain/dtos/Paginated.js";
import type { UserListQuery, UserDetailQuery, UserCreateRequest, UserUpdateRequest } from "@saif-reporting/domain/dtos/userDtos.js";

export class UserService implements IUserService {
  private readonly baseApi: IApi;
  constructor({ baseApi }: ContainerType) {
    this.baseApi = baseApi;
  }

  async getList(query: UserListQuery): Promise<Paginated<UserDto>> {
    const res = await this.baseApi.$fetch<Paginated<UserDto>>("/users", { query: query });
    return res;
  }

  async getOne(id: number, query: UserDetailQuery): Promise<UserDto> {
    const res = await this.baseApi.$fetch<UserDto>(`/users/${id}`, { query: query });
    return res;
  }

  async create(dto: UserCreateRequest): Promise<UserDto> {
    const res = await this.baseApi.$fetch<UserDto>(`/users`, { body: dto, method: "post" });
    return res;
  }

  async update(id: number, dto: UserUpdateRequest): Promise<UserDto> {
    const res = await this.baseApi.$fetch<UserDto>(`/users/${id}`, { body: dto, method: "patch" });
    return res;
  }

  async delete(id: number): Promise<UserDto> {
    const res = await this.baseApi.$fetch<UserDto>(`/users/${id}`, { method: "delete" });
    return res;
  }

  async changePassword(id: number, dto: ChangePasswordRequest): Promise<void> {
    await this.baseApi.$fetch(`/users/${id}`, { body: dto, method: "patch" });
  }
}
